<!-- Modal Project template list -->
<app-loadconfirm *ngIf="showSpinner" [text]="'projecttemplatelist.loader' | trans " [icon]="'pending'"></app-loadconfirm>
    <div *ngIf="!wizard" class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div *ngIf="step === 1" class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ 'projecttemplatelist.choosetemplates' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span >&times;</span>
          </button>
        </div>
        <div *ngIf="step === 2 && !showCustomerCreate" class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ 'projecttemplatelist.createyourproject' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span >&times;</span>
          </button>
        </div>
        <div *ngIf="step === 2 && showCustomerCreate" class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{ 'projecttemplatelist.createyourcustomer' | trans }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span >&times;</span>
          </button>
        </div>
        <div *ngIf="step === 1" class="modal-body">
          <div class="row">
            <div class="col-6">
              <p class="mb-0 font-weight-lighter">{{ 'projecttemplatelist.title' | trans }}</p>
            </div>
            <div class="col-3">
              <p class="mb-0 font-weight-lighter">{{ 'projecttemplatelist.description' | trans }}</p>
            </div>
            <div class="col-3">
              <p class="mb-0 font-weight-lighter">{{ 'projecttemplatelist.description' | trans }}</p>
            </div>
          </div>
          <div *ngFor="let template of templateList" (click)="chooseTemplate(template)"
          data-toggle="tooltip" type="button" data-placement="above" title="{{ 'projecttemplatelist.templatetip' | trans }}" class="row bg-grey-onhover mb-2 rounded">
            <div class="col-6">
              <p matTooltip="{{template.title}}" matTooltipPosition="above" matTooltipShowDelay="500" class="mb-0 lh-33 text-truncate align-middle">{{template.title}}</p>
            </div>
            <div class="col-3">
              <p matTooltip="{{template.templatedescription}}" matTooltipPosition="above" matTooltipShowDelay="500" class="mb-0 lh-33 text-truncate align-middle">{{template.templatedescription}}</p>
            </div>
            <div class="col-3">
              <p class="mb-0 lh-33 align-middle"><app-personname [viewtypeportal]="true" [personId]="template.creator"></app-personname></p>
            </div>
          </div>
        </div>
        <div class="pt-0 pb-2 pl-2 pr-2" *ngIf="step === 2">
        <div *ngIf="!showCustomerCreate">
          <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.projecttitle' | trans }}</p>
            <input class="form-control input-field" type="text" name="title"  [(ngModel)]="newProject.title" required>
            <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.subtitle' | trans }}</p>
            <input class="form-control input-field" type="text" name="subtitle"  [(ngModel)]="newProject.subtitle" required>
            <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.shortdescription' | trans }}</p>
            <textarea class="form-control sm-descript input-field" type="text" name="shortdescription"  [(ngModel)]="newProject.shortdescription" required></textarea>
            <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.description' | trans }}</p>
            <textarea class="form-control lg-descript input-field" type="text" name="projectdescription"  [(ngModel)]="newProject.projectdescription" required></textarea>
            <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.startdatehelp' | trans }} {{startday | date:'EEEE'}})</p>
            <input type="date" class="form-control stageinput input-field" name="startdate" (input)="setEndDate()" [(ngModel)]="newProject.start_date" required>
            <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.enddate' | trans }} {{newProject?.end_date | date:'dd-MM-yyyy'}}</p>
            <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.customer' | trans }}</p>
            <select (change)="setCustomer(newProject.customer)" id="customerchoise" name="customer" [(ngModel)]="newProject.customer" class="form-control input-field" required>
              <option selected>{{ 'projecttemplatelist.customerplace' | trans }}</option>
              <option *ngFor="let customer of customerList; let i = index" value="{{customer.customerId.split('_')[0]}}">{{customer.title}}</option>
            </select>
            <div  *ngIf="dealList && dealList.length > 0" class="form-group">
              <p class="mb-0 cursor-pointer">{{ 'projecttemplatelist.deal' | trans }}</p>
              <select  id="addcustomerdealchoise" name="deal" [(ngModel)]="newProject.dealId" class="form-control" required>
                <option *ngIf="!newProject.dealId" selected>{{ 'projecttemplatelist.dealplace' | trans }}</option>
                <option *ngFor="let deal of dealList" [ngValue]="deal.dealId" >{{deal.dealname}}</option>
              </select>
            </div>
            <!-- <div class="border-bottom mt-3 mb-3">
            </div> -->
            <!-- <div class="row">
              <div class="col">            
                <button type="button"  class="btn-save" data-dismiss="modal" (click)="openCreateCustomer()"><h6 class="btn-save-text">Create customer</h6></button>
              </div>
              <div class="col">
                <p class="mb-0 text-muted align-middle lh-25">Create customers assign projects to</p>
              </div>
            </div> -->
            </div>
            <app-customercreate *ngIf="showCustomerCreate" [fromproject]="true" (customerToAdd)="addCustomer($event)"></app-customercreate>
        </div>
        <div class="modal-footer" *ngIf="!showCustomerCreate && step === 2" >
          <div class="col pl-0" >
            <button type="button"  class="btn w-100" (click)="openCreateCustomer()"><h6 class="btn-text">{{ 'projecttemplatelist.createcustomer' | trans }}</h6></button>
          </div>
          <!-- <div class="col pl-0" *ngIf="showCustomerCreate">
            <button type="button" class="btn-close float-left" (click)="showCustomerCreate = false"><h6 class="btn-save-text">Close</h6></button>
          </div>
          <div class="col pl-0" *ngIf="!showCustomerCreate">
            <button type="button"  class="btn-close float-left" data-dismiss="modal" (click)="closeModal()"><h6 class="btn-save-text">Close</h6></button>
          </div> -->
           <!-- <div class="col">
            <button (click)="createProject()" type="button" data-dismiss="modal" class="btn-save float-right"><h6 class="btn-save-text">New Template</h6></button>
          </div> -->
          <div class="col pr-0">
            <button (click)="createProject()" type="button" data-dismiss="modal" class="btn-save float-right"><h6 class="btn-save-text">{{ 'projecttemplatelist.createfromtemplate' | trans }}</h6></button>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="wizard">
    <div *ngIf="step === 1 " class="pt-0 pb-0">
      <app-loadconfirm *ngIf="showLoader" [iconclass]="''" [text]="'projecttemplatelist.loader2' | trans " [icon]="'pending'"></app-loadconfirm>
      <div class="row mt-2">
        <div class="col-5">
          <p class="mb-0 font-weight-lighter">{{ 'projecttemplatelist.title' | trans }}</p>
        </div>
        <div class="col-4">
          <p class="mb-0 font-weight-lighter">{{ 'projecttemplatelist.description' | trans }}</p>
        </div>
        <div class="col-3">
          <p class="mb-0 font-weight-lighter">{{ 'projecttemplatelist.creator' | trans }}</p>
        </div>
      </div>
      <div *ngFor="let template of templateList" (click)="chooseTemplate(template)"
      data-toggle="tooltip" type="button" data-placement="above" title="{{ 'projecttemplatelist.templatetip' | trans }}" class="row bg-grey-onhover mb-2 rounded">
        <div class="col-5">
          <p matTooltip="{{template.title}}" matTooltipPosition="above" matTooltipShowDelay="500" class="mb-0 lh-33 align-middle text-truncate">{{template.title}}</p>
        </div>
        <div class="col-4">
          <p matTooltip="{{template.templatedescription}}" matTooltipPosition="above" matTooltipShowDelay="500" class="mb-0 lh-33 align-middle text-truncate">{{template.templatedescription}}</p>
        </div>
        <div class="col-3">
          <p class="mb-0 lh-33 align-middle"><app-personname [viewtypeportal]="true" [personId]="template.creator"></app-personname></p>

        </div>
      </div>
    </div>
    <div class="" *ngIf="step === 2">
    <div *ngIf="!showCustomerCreate">
      <div class="form-group">
        <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.projecttitle' | trans }}</p>
        <input class="form-control input-field" type="text" name="title"  [(ngModel)]="newProject.title" required>
      </div>
      <div class="form-group">
        <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.subtitle' | trans }}</p>
        <input class="form-control input-field" type="text" name="subtitle"  [(ngModel)]="newProject.subtitle" required>
      </div>
      <div class="form-group">
        <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.shortdescription' | trans }}</p>
        <textarea class="form-control sm-descript input-field" type="text" name="shortdescription"  [(ngModel)]="newProject.shortdescription" required></textarea>
      </div>
      <div class="form-group">
        <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.description' | trans }}</p>
        <textarea class="form-control lg-descript input-field" type="text" name="projectdescription"  [(ngModel)]="newProject.projectdescription" required></textarea>
      </div>
      <div class="form-group">
        <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.startdatehelp' | trans }} {{startday | date:'EEEE'}})</p>
        <input type="date" class="form-control stageinput input-field" name="startdate" (input)="setEndDate()" [(ngModel)]="newProject.start_date" required>
        <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.enddate' | trans }} {{newProject?.end_date | date:'dd-MM-yyyy'}}</p>
      </div>
      <div class="form-group">
        <p class="cursor-pointer mb-0">{{ 'projecttemplatelist.customer' | trans }}</p>
        <select (change)="setCustomer(newProject.customer)" id="customerchoise" name="customer" [(ngModel)]="newProject.customer" class="form-control input-field" required>
          <option selected>{{ 'projecttemplatelist.customerplace' | trans }}</option>
          <option *ngFor="let customer of customerList; let i = index" value="{{customer.customerId.split('_')[0]}}">{{customer.title}}</option>
        </select>
      </div>
      <div  *ngIf="dealList && dealList.length > 0" class="form-group">
        <p class="mb-0 cursor-pointer">{{ 'projecttemplatelist.deal' | trans }}</p>
        <select  id="addcustomerdealchoise" name="deal" [(ngModel)]="newProject.dealId" class="form-control" required>
          <option selected>{{ 'projecttemplatelist.dealplace' | trans }}</option>
          <option *ngFor="let deal of dealList" value="{{deal.dealId.split('_')[0]}}" >{{deal.dealname}}</option>
        </select>
      </div>
        <!-- <div class="border-bottom mt-3 mb-3">
        </div> -->
        <!-- <div class="row">
          <div class="col">            
            <button type="button"  class="btn-save" data-dismiss="modal" (click)="openCreateCustomer()"><h6 class="btn-save-text">Create customer</h6></button>
          </div>
          <div class="col">
            <p class="mb-0 text-muted align-middle lh-25">Create customers assign projects to</p>
          </div>
        </div> -->
        </div>
        <button (click)="createProject()" type="button" class="btn-save float-right mt-2"><h6 class="btn-save-text">{{ 'projecttemplatelist.createfromtemplate' | trans }}</h6></button>
         
        <app-customercreate *ngIf="showCustomerCreate" [fromproject]="true" (customerToAdd)="addCustomer($event)"></app-customercreate>
    </div>
  
  </ng-container>